export default __webpack_public_path__ + "static/media/LSCALOGO.8f25fca9.png";